import { render, staticRenderFns } from "./PosForm.vue?vue&type=template&id=0a118bea"
import script from "./PosForm.vue?vue&type=script&lang=js"
export * from "./PosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports